import api from './api';

export interface PopupStoreCrawl {
  id: number;
  crawlSource: string;
  sourceId: string;
  status: 'pending' | 'approved' | 'rejected';
  rawData: any;
  processedData: any;
  rejectReason: string | null;
  created_at: string;
  updated_at: string;
  approvedAt: string | null;
  approvedBy: number | null;
  popupStoreId: number | null;
}

export const PopupStoresCrawlService = {
  getAll: (status?: string) => {
    const params = status ? { status } : {};
    return api.get<PopupStoreCrawl[]>('/api/admin/v2/crawls', { params });
  },

  getOne: (id: number) => {
    return api.get<PopupStoreCrawl>(`/api/admin/v2/crawls/${id}`);
  },

  approve: (id: number) => {
    return api.post(`/api/admin/v2/crawls/${id}/approve`);
  },

  reject: (id: number, reason?: string) => {
    return api.post(`/api/admin/v2/crawls/${id}/reject`, { reason });
  },

  runCrawlNow: () => {
    return api.post('/api/admin/v2/crawls/run-now');
  },
};
